export const inventoryTemplatesKeys = {
  all: ["inventory-templates"] as const,
  lists: () => [...inventoryTemplatesKeys.all, "list"] as const,
  list: (filters: any) => [...inventoryTemplatesKeys.lists(), { filters }] as const,
  active: () => [...inventoryTemplatesKeys.all, "active"] as const,
  details: () => [...inventoryTemplatesKeys.all, "detail"] as const,
  detail: (id: string) => [...inventoryTemplatesKeys.details(), id] as const,
};
